export const DOMAIN_URL = process.env.NEXT_PUBLIC_ENV_WEBAPP_HOST_NAME;

export const AUTH_CLIENT_URL = process.env.NEXT_PUBLIC_ENV_AUTH_CLIENT_URL;
export const WEBAPP_URL = process.env.NEXT_PUBLIC_ENV_WEBAPP_HOST_NAME;
export const ADMIN_URL = process.env.NEXT_PUBLIC_ENV_ADMIN_HOST_NAME;
export const CINEMA_URL = process.env.NEXT_PUBLIC_ENV_CINEMA_HOST_NAME;
export const DISTRIBUTOR_URL = process.env.NEXT_PUBLIC_ENV_DISTRIBUTOR_HOST_NAME;
export const CDN_URL = process.env.NEXT_PUBLIC_ENV_CDN_HOST_NAME;
export const PAYMENT_URL = process.env.NEXT_PUBLIC_ENV_PAYMENT_HOST_NAME;
export const AUTH_URL = process.env.NEXT_PUBLIC_ENV_AUTH_HOST_NAME;

/**
 * The id app's logout ROUTE, not its landing page. The route POSTs `auth/logout` to kill the IdP
 * session (`cineamo_local`) and only then shows "logout successful"; going straight to the page
 * would leave that cookie alive, and the next visit to any app would be auto-approved at
 * /oauth/authorize — an invisible re-login. The locale rides as a query param because the route
 * lives outside `[locale]`.
 */
export const SIGNOUT_URL = (locale?: string): string => {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : '';
    return !AUTH_CLIENT_URL?.startsWith('/') // '/login' vs a real host like 'staging.cineamo.com'
        ? `${AUTH_CLIENT_URL}/api/logout${query}`
        : `/api/logout${query}`;
};

export const SIGNIN_URL = (locale?: string, urlParams?: string): string => {
    let url = !AUTH_CLIENT_URL?.startsWith('/') // Check if AUTH_URL is equal to e.g. '/login' or another domain like 'cineamo.dev'
        ? AUTH_CLIENT_URL + (locale ? `/${locale}` : '')
        : AUTH_CLIENT_URL + urlParams;
    if (!!urlParams && urlParams.length > 0) {
        url += urlParams;
    }
    return url;
};

export const ANDROID_APP_ID = 'org.mpp.cineamo';
export const APPLE_APP_ID = '1447730281';
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_APP_ID}&referrer=utm_source%3Dcineamo.com%26utm_medium%3Dlandingpage%26utm_campaign%3Dwebsite-cta`;
export const APP_STORE_URL = `https://apps.apple.com/app/apple-store/id${APPLE_APP_ID}?pt=120760330&ct=Cineamo-Landing-Page&mt=8`;
export const KINOCLOUD_CINEAMO_MOVIELIBRARY_URL = 'https://app.kinocloud.de/pages/filmbibliothek/apps/content/app';
